
export enum TipoPersona {
    Fisica,
    Moral
}

/**Identificación de una persona. Un cliente o un contacto debe de tener por lo menos uno de estos campos asignados y estos campos deben de ser unicos entre si */
export interface Identificacion  {
    /**
     * Numero del INE/IFE
     */
    Ine: string;

    /**Numero de RFC */
    Rfc: string;

    /**Tipo de persona */
    TipoPersona: TipoPersona | null;

    /**Numero de CURP */
    Curp: string;

    /**Numero de pasaporte */
    Pasaporte: string;

    /**Tipo de persona */
    IdUsuariozePatron: number | null;
}


// WEBPACK FOOTER //
// ./app/models/identificacion.ts